<template>
  <div>
    <my-header></my-header>

    <div class="page">

      <b-breadcrumb class="place">
        <b-breadcrumb-item :to="{name:'contest_info'}">Contest {{contestId}}</b-breadcrumb-item>
        <b-breadcrumb-item :to="{name:'contest_groups'}">Groups</b-breadcrumb-item>
      </b-breadcrumb>

      <h2>Игрок {{playerId}} (участник конкурса)</h2>

      <div class="section-container">
        <side-nav
          :menuItems="menuItems"
          class="side-nav"
        />

        <div class="content-box">
          <router-view></router-view>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'ContestPlayer',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    contestPlayerId: {
      type: Object,
      required: true
    }
  },

  computed: {
    /** @returns {number} */
    contestId() {
      return this.contestPlayerId.contestId;
    },

    /** @returns {number} */
    playerId() {
      return this.contestPlayerId.playerId;
    },

    menuItems() {
      return [
        {
          title: 'Информация',
          route: {name: 'contest_player_info', params: {contestPlayerId: this.contestPlayerId}},
        },
        // TODO: Добавить раздел "Метрики" (contest metrics).
        {
          title: 'История очков',
          route: {name: 'contest_player_score_history', params: {contestPlayerId: this.contestPlayerId}},
        },
        {
          title: 'Награды',
          route: {name: 'contest_player_rewards', params: {contestPlayerId: this.contestPlayerId}},
        },
      ];
    },
  },
};
</script>

<style scoped>
.section-container {
  display: flex;
  align-items: flex-start;
}

.page {
  margin-left: 1rem;
}

.place {
  max-width: 600px;
}

.side-nav {
  margin-right: 2rem;
  background-color: rgb(242, 247, 251);
}

.content-box {
  width: 600px;
}
</style>
